var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{staticClass:"flex gap-10"},[_c('RadioButton',{attrs:{"title":_vm.firstTitle,"option":_vm.firstOption,"value":_vm.getValue,"name":_vm.name},on:{"input":_vm.click}}),_c('RadioButton',{attrs:{"title":_vm.secondTitle,"option":_vm.secondOption,"value":_vm.getValue,"name":_vm.name},on:{"input":_vm.click}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }